
module.exports = {
  // TODO: change your profile information here
  name: "Shubham Singh",
  greeting: "Hey 👋",
  greetingDescription: "I'm Shubham Singh and I'm a Computer engineering student interested in Artificial Intelligence!",
  githubUrl: "https://github.com/shubhamcodez",
  linkedinUrl: "https://www.linkedin.com/in/shubhamcodez/",
  cvLink: "https://drive.google.com/file/d/1WaX3kuOCGKjJv4ojY3XTavHhp8mkqNg-/view?usp=sharing",
};
